export default {
  MIN_MARK: 2,
}
